module.exports = __webpack_public_path__ + "media/images/general-aa3489f7eea269d3484897bef04abe4c.png";